module.exports = __webpack_public_path__ + "static/media/Grief AndLossActive.d0c3e630.svg";